import { CountryCode } from '@gql/graphql';
import type { ProListPageControllerFormValues } from '.';

export const PAGINATED_SIZE = 10;

export const DISTANCE_TO_ZOOM_MAP: Record<number, number> = {
  200000: 7,
  100000: 8,
  50000: 9,
  30000: 10,
  20000: 10,
  10000: 11,
  5000: 13,
};

export const PROS_MAP_INITIAL_VALUES: Record<CountryCode, ProListPageControllerFormValues> = {
  [CountryCode.FR]: {
    zoom: 11,
    mapCenter: {
      lat: 48.864263057433895,
      lng: 2.352530411847944,
    },
    hasBooking: undefined,
    spokenLanguages: [],
    maxDistance: undefined,
    bounds: undefined,
    educatorTypes: [],
  },
  [CountryCode.BE]: {
    zoom: 11,
    mapCenter: {
      lat: 50.8388757,
      lng: 4.3746338,
    },
    hasBooking: undefined,
    spokenLanguages: [],
    maxDistance: undefined,
    bounds: undefined,
    educatorTypes: [],
  },
  [CountryCode.NL]: {
    zoom: 11,
    mapCenter: {
      lat: 52.3465610683968,
      lng: 4.922552334042055,
    },
    hasBooking: undefined,
    spokenLanguages: [],
    maxDistance: undefined,
    bounds: undefined,
    educatorTypes: [],
  },
  [CountryCode.DE]: {
    zoom: 11,
    mapCenter: {
      lat: 52.52,
      lng: 13.405,
    },
    hasBooking: undefined,
    spokenLanguages: [],
    maxDistance: 100000,
    bounds: undefined,
    educatorTypes: [],
  },
  [CountryCode.CH]: {
    zoom: 11,
    mapCenter: {
      lat: 46.94393405536843,
      lng: 7.4569594015286675,
    },
    hasBooking: undefined,
    spokenLanguages: [],
    maxDistance: 100000,
    bounds: undefined,
    educatorTypes: [],
  },
  [CountryCode.EU]: {
    zoom: 8,
    mapCenter: {
      lat: 50.8388757,
      lng: 4.3746338,
    },
    hasBooking: undefined,
    spokenLanguages: [],
    maxDistance: undefined,
    bounds: undefined,
    educatorTypes: [],
  },
};
export const EDUCATOR_MAP_INITIAL_VALUES = PROS_MAP_INITIAL_VALUES;
